import { Box, SxProps, useTheme } from "@mui/material"
import React, { PropsWithChildren } from "react"
import { useMediaQuery } from "react-responsive"
import { useNavigate } from "react-router-dom"
import { ArrowRightIcon } from "./icons/ArrowRightIcon"
import { Typography } from "./Typography"

export const ViewMore: React.FC<
  PropsWithChildren<{
    to?: string
    sx?: SxProps
    size?: "small" | "medium" | "large"
    color?: "textPrimary" | "textSecondary"
  }>
> = ({ to, sx, size = "medium", children, color = "textPrimary" }) => {
  const navigate = useNavigate()
  const theme = useTheme()

  const isPC = useMediaQuery({ query: "(min-width: 1050px)" })

  const TypographyComponent =
    size === "medium"
      ? Typography.SubHead
      : size === "small"
      ? Typography.SubTitle
      : Typography.Larger

  return (
    <Box display="flex" mt={isPC ? 0 : "20px"} onClick={() => to && navigate(to)} sx={sx}>
      <TypographyComponent
        fontWeight={500}
        mr={2.5}
        color={color}
        overflow="hidden"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        fontFamily="Noto Sans JP !important"
        sx={{ my: "auto" }}
      >
        {children}
      </TypographyComponent>
      <ArrowRightIcon
        color={color === "textPrimary" ? theme.palette.text.primary : theme.palette.text.secondary}
        width="13"
        height="26"
        sx={{ height: "20px" }}
      />
    </Box>
  )
}
